module.exports = __webpack_public_path__ + "static/media/exclamation.6de0d3d2.svg";